// extracted by mini-css-extract-plugin
export default {"partner":"Partner_partner__rXQua","title":"Partner_title__wiE1F","partnerBox":"Partner_partnerBox__Aito3","img":"Partner_img__Geese"};